import React, { memo } from 'react';

import { amount } from 'common/propTypes';
import AmountStrip from '../AmountStrip';

const DetailsFooter = ({ totalAmount, originalAmount }) => {
  const showCryptoAmount =
    originalAmount?.currency &&
    totalAmount.currency !== originalAmount.currency;

  return (
    <footer>
      <AmountStrip
        heading="Total amount"
        amount={totalAmount}
        background="rebranding-md-color-brand-purple-lightest"
        cryptoAmount={showCryptoAmount ? originalAmount : undefined}
      />
    </footer>
  );
};

DetailsFooter.propTypes = {
  totalAmount: amount.isRequired,
  originalAmount: amount,
};

export default memo(DetailsFooter);
